import React, { useState } from 'react'
import Child from './Child'
import Header from './Header'
import Footer from './Footer'

const Parent = () => {
    let i = 'iLander'
    let [y,setY]=useState('')

    let receive1=(data)=>{
        setY(JSON.stringify(data))
    }
  return (
    <>
    <Header />
      <div className="container">
        <div className="row my-5">
            <div className="col-md-6 mx-auto">
                <div className="card">
                    <div className="card-header">
                        <h1>Parent Component {y}</h1>
                    </div>
                    <div className="card-body">
                        <Child name={i} fun={receive1} />
                    </div>
                </div>
            </div>
        </div>
      </div>
    <Footer />  
    </>
  )
}

export default Parent
